/**
 * lod — política de TESSELAÇÃO dos avatares (carro/pessoa).
 *
 * Por que existe: as mesmas peças são usadas em dois contextos com exigências
 * MUITO diferentes de detalhe:
 *
 *   • JOGO (Fleet): câmera aérea. Na vista padrão 1 unidade de mundo ≈ 9 px, e o
 *     avatar é escalado ~1,2× — ou seja, a cabeça de um pedestre tem ~8 px de
 *     diâmetro na tela e o fillet de um friso de 0,02 não chega a 1/4 de pixel.
 *     Com centenas de avatares, cada triângulo é multiplicado por N: um pedestre
 *     custava 26.840 triângulos para desenhar algo do tamanho de uma unha.
 *
 *   • ESTÚDIO (/models e retrato de conquista): UM avatar ocupando a tela. Aqui o
 *     esfericidade e os perfis curvos aparecem de verdade e o custo é irrelevante.
 *
 * O que NÃO muda entre os dois: a lista de peças, posições, rotações, variantes e
 * cores — tudo que define a APARÊNCIA continua sendo fonte única (ver
 * partsRuntime). Só a densidade de vértices de cada primitiva varia. Assim um
 * refinamento de modelo continua valendo nos dois lugares, como sempre.
 *
 * Uso: `buildCarParts('studio')` / `buildPersonParts('studio')` nos consumidores
 * de close-up; sem argumento = 'game' (o padrão, usado pelo Fleet).
 */

let MODE = 'game';

/** Troca o modo e devolve o anterior (os builders restauram no fim). */
export function setAvatarDetail(mode) {
  const prev = MODE;
  MODE = mode === 'studio' ? 'studio' : 'game';
  return prev;
}

export function avatarDetail() {
  return MODE;
}

/** Reduz `v` pelo fator `f` sem NUNCA passar do original nem cair abaixo de `floor`. */
const lower = (v, f, floor) => Math.min(v, Math.max(floor, Math.round(v * f)));

// Box-like pieces use a fixed 44-triangle planar bevel in both views.
// Only curved silhouettes below change their sampling between game and studio.

/** Segmentos (largura, altura) de uma SphereGeometry. */
export function sphSeg(w, h) {
  if (MODE === 'studio') return [w, h];
  return [lower(w, 0.65, 6), lower(h, 0.65, 5)];
}

/** Segmentos radiais de uma CylinderGeometry. */
export function cylSeg(s) {
  if (MODE === 'studio') return s;
  return lower(s, 0.6, 8);
}

/** `curveSegments` de uma ExtrudeGeometry (arcos de para-lama etc.). */
export function curveSeg(s) {
  if (MODE === 'studio') return s;
  return lower(s, 0.6, 8);
}
